import EmployeeSalaryOvertimeComponents from "../components/EmployeeSalaryOvertime";
import useEmployeeSalaryOvertime from "../hooks/useEmployeeSalaryOvertime";

function EmployeeSalaryOvertime() {
  const employeeSalaryOvertimeProps = useEmployeeSalaryOvertime();
  return <EmployeeSalaryOvertimeComponents {...employeeSalaryOvertimeProps} />;
}

export default EmployeeSalaryOvertime;
